export default {
  methods: {
    async goTo({ link }) {
      this.$router.push(link).catch(() => {});
    },
  },
};
